<div
  class="horizontal-scroller"
  [ngClass]="{ bordered: isBackgroundLight, small: isSmall }">
  <div
    class="scroll-container"
    [class.overflow-visible]="overflowVisible"
    #scrollContainer
    (mousedown)="onMouseDown($event)"
    (touchstart)="onTouchStart($event)"
    (mousemove)="onMouseMove($event)"
    (touchmove)="onTouchMove($event)"
    (mouseup)="onMouseUp($event)"
    (touchend)="onTouchEnd($event)">
    <ng-content></ng-content>
  </div>
  <div class="scroll-buttons-container">
    <div #leftArrow class="scroll-btn-container left pointer">
      <button
        class="scroll-btn"
        (mousedown)="onScroll('left', $event)"
        (mouseup)="onStopScrolling($event)"
        (mouseleave)="onStopScrolling($event)">
        <span class="scroll-btn-content">
          <span class="icon icon-arrow-left"></span>
        </span>
      </button>
    </div>
    <div #rightArrow class="scroll-btn-container right pointer">
      <button
        class="scroll-btn"
        (mousedown)="onScroll('right', $event)"
        (mouseup)="onStopScrolling($event)"
        (mouseleave)="onStopScrolling($event)">
        <span class="scroll-btn-content">
          <span class="icon icon-arrow-right"></span>
        </span>
      </button>
    </div>
  </div>
</div>
